// Newsletter action types
export const SUBSCRIBE_NEWSLETTER_REQUEST = 'SUBSCRIBE_NEWSLETTER_REQUEST';
export const SUBSCRIBE_NEWSLETTER_SUCCESS = 'SUBSCRIBE_NEWSLETTER_SUCCESS';
export const SUBSCRIBE_NEWSLETTER_FAILURE = 'SUBSCRIBE_NEWSLETTER_FAILURE';

export const CONFIRM_SUBSCRIPTION_REQUEST = 'CONFIRM_SUBSCRIPTION_REQUEST';
export const CONFIRM_SUBSCRIPTION_SUCCESS = 'CONFIRM_SUBSCRIPTION_SUCCESS';
export const CONFIRM_SUBSCRIPTION_FAILURE = 'CONFIRM_SUBSCRIPTION_FAILURE';

export const UNSUBSCRIBE_NEWSLETTER_REQUEST = 'UNSUBSCRIBE_NEWSLETTER_REQUEST';
export const UNSUBSCRIBE_NEWSLETTER_SUCCESS = 'UNSUBSCRIBE_NEWSLETTER_SUCCESS';
export const UNSUBSCRIBE_NEWSLETTER_FAILURE = 'UNSUBSCRIBE_NEWSLETTER_FAILURE';

export const FETCH_SUBSCRIBERS_REQUEST = 'FETCH_SUBSCRIBERS_REQUEST';
export const FETCH_SUBSCRIBERS_SUCCESS = 'FETCH_SUBSCRIBERS_SUCCESS';
export const FETCH_SUBSCRIBERS_FAILURE = 'FETCH_SUBSCRIBERS_FAILURE';

export const FETCH_SUBSCRIBERS_COUNT_REQUEST = 'FETCH_SUBSCRIBERS_COUNT_REQUEST';
export const FETCH_SUBSCRIBERS_COUNT_SUCCESS = 'FETCH_SUBSCRIBERS_COUNT_SUCCESS';
export const FETCH_SUBSCRIBERS_COUNT_FAILURE = 'FETCH_SUBSCRIBERS_COUNT_FAILURE';


